import styled from "@emotion/styled";

import {calculateRemSize} from "@pg-design/helpers-css";

import {slickSlider} from "../../../app/styles/slick_slider";
export const SlickWrapper = styled.div<{isOnFirstSlide: boolean; isOnLastSlide: boolean}>`
    ${slickSlider};
    margin: 0 -${calculateRemSize(1)};

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        padding: 0;
    }

    .slick-slide {
        height: inherit;

        > div {
            height: 100%;
        }
    }

    .slick-list {
        @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
            padding-left: ${(props) =>
                props.isOnLastSlide ? "calc(100% - 302px - 16px)" : props.isOnFirstSlide ? "1.6rem" : "calc((100% - 302px - 8px) / 2)"};
        }

        @media (min-width: ${(props) => props.theme.breakpoints.xs}) and (max-width: ${(props) => props.theme.breakpoints.md}) {
            padding-left: ${(props) =>
                props.isOnLastSlide ? "calc(100% - 360px - 16px)" : props.isOnFirstSlide ? "1.6rem" : "calc((100% - 360px - 8px) / 2)"};
        }

        @media (min-width: ${(props) => props.theme.breakpoints.md}) {
            margin-right: -2.4rem;

            &:after {
                content: "";
                width: 2.4rem;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                background-color: ${(props) => props.theme.colors.gray["100"]};
            }
        }
    }
    .slick-track {
        margin: 1rem 0;
        display: flex;
        @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
            column-gap: 1.6rem;
        }

        @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
            margin: 2rem 0 4rem 0;
        }
    }

    .slick-arrow {
        width: 0; // disable additional navigation area - it was causing issues with clicking on offer boxes
    }

    .slick-prev,
    .slick-next {
        display: none !important;
        @media (min-width: ${(props) => props.theme.breakpoints.md}) {
            display: block !important;
        }
        &::before {
            display: none;

            @media (min-width: ${(props) => props.theme.breakpoints.md}) {
                display: block;
            }
        }
    }

    .slick-disabled {
        display: none !important;
    }
`;
import styled from "@emotion/styled";

import {calculateRemSize} from "@pg-design/helpers-css";

import {slickSlider} from "../../../app/styles/slick_slider";
export const SlickWrapper = styled.div<{isOnFirstSlide: boolean; isOnLastSlide: boolean}>`
    ${slickSlider};
    margin: 0 -${calculateRemSize(1)};

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        padding: 0;
    }

    .slick-slide {
        height: inherit;

        > div {
            height: 100%;
        }
    }

    .slick-list {
        @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
            padding-left: ${(props) =>
                props.isOnLastSlide ? "calc(100% - 302px - 16px)" : props.isOnFirstSlide ? "1.6rem" : "calc((100% - 302px - 8px) / 2)"};
        }

        @media (min-width: ${(props) => props.theme.breakpoints.xs}) and (max-width: ${(props) => props.theme.breakpoints.md}) {
            padding-left: ${(props) =>
                props.isOnLastSlide ? "calc(100% - 360px - 16px)" : props.isOnFirstSlide ? "1.6rem" : "calc((100% - 360px - 8px) / 2)"};
        }

        @media (min-width: ${(props) => props.theme.breakpoints.md}) {
            margin-right: -2.4rem;

            &:after {
                content: "";
                width: 2.4rem;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                background-color: ${(props) => props.theme.colors.gray["100"]};
            }
        }
    }
    .slick-track {
        margin: 1rem 0;
        display: flex;
        @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
            column-gap: 1.6rem;
        }

        @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
            margin: 2rem 0 4rem 0;
        }
    }

    .slick-arrow {
        width: 0; // disable additional navigation area - it was causing issues with clicking on offer boxes
    }

    .slick-prev,
    .slick-next {
        display: none !important;
        @media (min-width: ${(props) => props.theme.breakpoints.md}) {
            display: block !important;
        }
        &::before {
            display: none;

            @media (min-width: ${(props) => props.theme.breakpoints.md}) {
                display: block;
            }
        }
    }

    .slick-disabled {
        display: none !important;
    }
`;
